<script>
import { mapActions } from 'vuex'

export default {
  name: 'DriverMasterItemEdit',
  components: {},
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '品目一覧', disabled: false, to: '/driver/masters/items', exact: true },
        { text: '品目追加', disabled: true, to: '' },
      ],
      targetType: null,
      items: [],
      handleItems: null,
      check_control: false
    }
  },
  watch: {
  },
  created() {

    this.targetType = this.$route.params.type;

    /**
     * JWNET取扱品目一覧の取得
     * @typedef content
     * @type Object
     * @property items { Array }
     */
    this.fetchItems({ type: this.targetType }).then((content) => {
      this.items = content.items
      /**
       * @typedef content { Object }
       * @property handle_items { Array }
       */
      this.editHandleItems({ type: this.targetType }).then((content) => {
        this.handleItems = content.handle_items
      })
    })
  },
  methods: {

    /**
     * JWNET取扱品目
     */
    ...mapActions('DriverMasterItem', {
      fetchItems: 'fetchBy'
    }),

    /**
     * テナント 取扱品目
     */
    ...mapActions('DriverMasterHandleItem', {
      editHandleItems: 'edit',
      createHandleItems: 'create',
    }),

    /**
     * 閉じるボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$router.push({name: 'DriverMasterItems' })
    },

    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let params = { type: this.targetType, item_ids: this.handleItems }
      this.createHandleItems({ params: params }).then(() => {
        this.$router.push({name: 'DriverMasterItems' })
      })
    },

    /**
     * 全選択/全解除チェックボックス クリックイベント
     */
    checkControlClickEvent () {
      const extractIds = (items) => {
        let ids = []
        for (const item of items) {
          ids.push(item.id)
          if (item.children) {
            ids.push(extractIds(item.children))
          }
        }
        return ids.flat()
      }
      if (this.check_control) {
        this.handleItems = extractIds(this.items)
      } else {
        this.handleItems = []
      }
    },

    /**
     * ページタイトルの設定
     * @return {string}
     */
    pageTitle () {
      let title = null;
      switch (this.targetType) {
        case "industrial":
          title = "産業廃棄物"
          break;
        case "specific_industrial":
          title = "特定産業廃棄物"
          break;
        case "general":
          title = "一般廃棄物"
          break;
        default:
          title = null;
      }
      return title;
    },
  }
}
</script>

<!-- 品目追加 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title v-if="pageTitle() !== null">{{ pageTitle() }}の追加</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-subtitle>
        <v-checkbox
          dense
          v-model="check_control"
          :label="check_control ? '全解除' : '全選択'"
          @click="checkControlClickEvent"
        />
      </v-card-subtitle>
      <v-card-text>
        <v-treeview
          v-if="handleItems"
          ref="tree"
          v-model="handleItems"
          :items="items"
          item-key="id"
          open-all
          open-on-click
          selection-type="independent"
          selected-color="primary"
          selectable
        >
          <template v-slot:label="{ item }">
            {{ item.code }}: {{ item.name }}
          </template>
        </v-treeview>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="!handleItems?.length"
          color="primary"
          @click="registerButtonClickEvent"
        >
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>


<style scoped>

</style>
